import module from "../module";
import Constants from "../../../utils/CommonConstants";
import scopeUtils from '../../../utils/scope';

export class InviteUserController {
  static $inject = ['$scope', 'CartService', '$rootScope', '$mdDialog', 'Message', '$translate'];

  constructor(scope, cartService, rootScope, dialogService, messageService, translate) {
    this._scope = scope;

    this._rootScope = rootScope;
    this._cartService = cartService;
    this._messageService = messageService;
    this._dialogService = dialogService;
    this.translate = translate;

    scope.inviteEmails = '';
    scope.sendInvitation = () => this._sendInvitation();
    scope.cancel = () => this._cancel();

    rootScope.$on(Constants.Events.BACK_BUTTON_CLICKED, () => dialogService.hide());

    this.initialize();
  }

  async initialize() {
    this._rootScope.storeWindowTitle = 'client.order.invite_user';
    this._rootScope.$broadcast(Constants.Events.DIALOG_OPENED, true);
  }

  _cancel() {
    this._dialogService.hide();
  }

  async _sendInvitation() {
    const emails = this._scope.inviteEmails.split(/[\n\r,;]+/)
      .map((e) => e.trim())
      .filter((e, index, arr) => !!e && arr.indexOf(e) === index);

    if (emails.length === 0) {
      this._scope.errorMessage = 'client.invite_user.email_error';
      return;
    }
    this._scope.inProgress = true;
    try {
      await this._cartService.sendInvites(emails);
      this._messageService.showMessagePopup(this.translate.instant('client.invite_user.success'));
      this._dialogService.hide();
    } catch (e) {
      this._scope.errorMessage = e.data && e.data.message || 'client.invite_user.api_error';
    } finally {
      this._scope.inProgress = false;
    }

    scopeUtils.apply(this._scope);

  }
}

module.controller('InviteUser', InviteUserController);




// WEBPACK FOOTER //
// ./src/modules/order/controllers/InviteUserController.js